module.exports = __webpack_public_path__ + "images/psa_small6cf5a1cdf2ee2f667975350d649689b6.png";